module.exports = __webpack_public_path__ + "img/help-image.9a625190.png";